export const DEFAULT_GUIDE_COUNT = 4;

export const createEvenGuidePositions = (count = DEFAULT_GUIDE_COUNT) => {
  const safeCount = Math.max(0, Math.floor(Number(count) || 0));
  return Array.from(
    { length: safeCount },
    (_, index) => (index + 1) / (safeCount + 1),
  );
};

export const DEFAULT_PREVIEW_GUIDES = Object.freeze({
  enabled: false,
  vertical: Object.freeze(createEvenGuidePositions()),
  horizontal: Object.freeze(createEvenGuidePositions()),
});

export const clampGuidePosition = (value) =>
  Math.min(1, Math.max(0, Number(value) || 0));

const normalizePositions = (positions, fallback) => {
  if (!Array.isArray(positions)) return [...fallback];
  return positions
    .map((position) => Number(position))
    .filter(Number.isFinite)
    .map(clampGuidePosition);
};

export const normalizePreviewGuides = (guides) => ({
  enabled: Boolean(guides?.enabled),
  vertical: normalizePositions(
    guides?.vertical,
    DEFAULT_PREVIEW_GUIDES.vertical,
  ),
  horizontal: normalizePositions(
    guides?.horizontal,
    DEFAULT_PREVIEW_GUIDES.horizontal,
  ),
});

export const resetPreviewGuides = (guides) => ({
  enabled: Boolean(guides?.enabled),
  vertical: createEvenGuidePositions(),
  horizontal: createEvenGuidePositions(),
});

export const evenlySpacePreviewGuides = (guides) => {
  const normalized = normalizePreviewGuides(guides);
  return {
    ...normalized,
    vertical: createEvenGuidePositions(normalized.vertical.length),
    horizontal: createEvenGuidePositions(normalized.horizontal.length),
  };
};

export const clearPreviewGuides = (guides) => ({
  enabled: Boolean(guides?.enabled),
  vertical: [],
  horizontal: [],
});
